import { observer } from 'mobx-react-lite'
import { VerifyComponent } from '../../../layouts/components/user/VerifyComponent'
import controller from '../controllers/user.controller'
import { Button } from 'antd'
import { MailOutlined, ReloadOutlined } from '@ant-design/icons'
import i from '../../../translations/i'
import { VerifySuccessComponent } from '../../../layouts/components/user/VerifySuccessComponent'
import { Helmet } from 'react-helmet'
import { storeSession } from '../../../helpers/stores'
import { AuthError, AuthHead, AuthSwitch } from '../shell/AuthShell'

export const Verify = observer(() => {

    const email = storeSession.get('verification_email')

    return !controller.verifyStatus ? (
        <>
            <Helmet>
                <title>{i.t('auth:title.verify')}</title>
            </Helmet>

            <AuthHead
                icon={<MailOutlined />}
                title={i.t('authShell:verify.title')}
                text={email ? i.t('authShell:verify.sentTo', { email }) : i.t('auth:verify.text')}
            />

            <form className="au-form" onSubmit={(e) => controller.verify(e)}>
                <AuthError message={controller.error} />

                <div className="au-code">
                    <VerifyComponent onChange={(e: any) => controller.onChangeVerify(e)} error={controller.error !== ''} value={controller.dataVerify.code} />
                    <Button type="link" icon={<ReloadOutlined />} onClick={() => controller.newCode()}>
                        {i.t('auth:verify.code')}
                    </Button>
                </div>

                <Button size="large" type="primary" htmlType="submit" block>
                    {i.t('def:actions.continue')}
                </Button>
            </form>

            <AuthSwitch text={i.t('authShell:verify.wrongEmail')} link={i.t('authShell:register.login')} href="/login" />
        </>
    ) : <VerifySuccessComponent />
})
